import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ion-common-retry',
  templateUrl: './retry.component.html',
  styleUrls: ['./retry.component.scss'],
})
export class RetryComponent {

  @Input()
  headerId = '';
  @Input()
  ariaLevelTitle = 1;
  @Input()
  title = 'Algo saiu do controle, mas já estamos resolvendo para você.';
  @Input()
  ariaTitle = 'Algo saiu do controle, mas já estamos resolvendo para você';
  @Output()
  sendEventRetry = new EventEmitter();


}
